import { HelmetDexteel } from "@dexteel/mesf-core";
import { TimerSpeedReport } from "./components/TimerSpeedReport";

export const TimerSpeedReportPage = () => {
	return (
		<>
			<HelmetDexteel title="Timer Speed Report" />
			<TimerSpeedReport />
		</>
	);
};
